import {
  EmployerFooter,
  EmployerHeader,
  type AnalyticsEvent,
  type EmployerSiteName,
} from '@seek/adv-header-footer';
import type { Locale } from '@seek/melways-sites';

import { useTracking } from 'src/App/context/TrackingProvider';
import { useQueryAccountInfo } from 'src/App/hooks/useQueryAccountInfo';
import { Environment } from 'src/App/services/environment';

type HeaderFooterProps = {
  site: EmployerSiteName;
  language: string;
  environment: Environment;
};

export const Header = ({ site, language, environment }: HeaderFooterProps) => {
  const { error: queryAccountError, accountInfo } = useQueryAccountInfo();
  const { trackLink } = useTracking();

  const props = {
    ...accountInfo,
    site,
    locale: language as Locale,
    basic: false,
    activeTabId: 'products' as const,
    activeSubTabId: 'discounts' as const,
    accountInfo,
    error: queryAccountError,
    isStaging: environment === Environment.staging,
    /* null = unauthenticated; undefined = pending */
    identityContext: accountInfo ? accountInfo.identityContext : null,
    onTrackedItemInteraction: (analyticsEvent: AnalyticsEvent) => {
      trackLink({
        eventName: analyticsEvent.eventName,
        data: {
          ...analyticsEvent,
        },
      });
    },
  };

  return <EmployerHeader {...props} />;
};

export const Footer = ({ site, language, environment }: HeaderFooterProps) => {
  const { accountInfo } = useQueryAccountInfo();
  const { trackLink } = useTracking();

  const props = {
    site,
    identityContext: accountInfo ? accountInfo.identityContext : null,
    advertiser: accountInfo?.advertiser,
    locale: language as Locale,
    isStaging: environment === Environment.staging,
    onTrackedItemInteraction: (analyticsEvent: AnalyticsEvent) => {
      trackLink({
        eventName: analyticsEvent.eventName,
        data: {
          ...analyticsEvent,
        },
      });
    },
  };

  return <EmployerFooter {...props} />;
};
